import { render } from "./ComBochart.vue?vue&type=template&id=7ae45d67"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/ComBochart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ae45d67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ae45d67', __exports__)) {
    api.reload('7ae45d67', __exports__)
  }
  
  module.hot.accept("./ComBochart.vue?vue&type=template&id=7ae45d67", () => {
    api.rerender('7ae45d67', render)
  })

}


export default __exports__